import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { FileText, ArrowRight, Home, Sprout, Leaf, BookOpen } from 'lucide-react';
const VIDEOS = [{
  title: 'Acuerdos de conservación en el territorio',
  src: 'https://play.gumlet.io/embed/6a351808ba0085952b28938e'
}, {
  title: 'El trabajo junto a las comunidades del PNN Paramillo',
  src: 'https://play.gumlet.io/embed/6a3518665c94624b773e920e'
}];
const HORIZONTAL_VIDEO = {
  title: 'Resultados de los acuerdos de conservación',
  src: 'https://play.gumlet.io/embed/6a35197f5c94624b773eb4c2'
};
const VERTICAL_VIDEOS = [{
  title: 'Voces del territorio',
  src: 'https://play.gumlet.io/embed/6a35197f83334b304cb8fc9d'
}, {
  title: 'Conservación en marcha',
  src: 'https://play.gumlet.io/embed/6a35197f83334b304cb8fc99'
}];
const BOLETINES = [{
  label: 'Boletín 1',
  href: 'https://programatefos.com/wp-content/uploads/2026/06/BOLETIN_1_ACUERDOS_C5.pdf'
}, {
  label: 'Boletín 2',
  href: 'https://programatefos.com/wp-content/uploads/2026/06/BOLETIN_2_ACUERDOS_C5.pdf'
}, {
  label: 'Boletín 3',
  href: 'https://programatefos.com/wp-content/uploads/2026/06/BOLETIN_3_ACUERDOS_C5.pdf'
}, {
  label: 'Boletín 4',
  href: 'https://programatefos.com/wp-content/uploads/2026/06/BOLETIN_4_ACUERDOS_C5.pdf'
}, {
  label: 'Boletín 5',
  href: 'https://programatefos.com/wp-content/uploads/2026/06/BOLETIN_5_ACUERDOS_C5.pdf'
}, {
  label: 'Boletín 6',
  href: 'https://programatefos.com/wp-content/uploads/2026/06/BOLETIN_6_ACUERDOS_C5.pdf'
}];
const ACTIONS = [{
  icon: Home,
  label: 'Mejoramiento de viviendas rurales'
}, {
  icon: Sprout,
  label: 'Sistemas agroforestales de cacao'
}, {
  icon: Leaf,
  label: 'Restauración ecológica con especies nativas'
}, {
  icon: BookOpen,
  label: 'Educación ambiental en Uré y Saiza'
}];
export function AcuerdosPNN() {
  return <section id="hito-3" className="py-24 md:py-32 px-4 md:px-8 bg-bone-dark scroll-mt-24" data-id="element-15" data-mp="2cl0rl3fhkkv6">
      <div className="max-w-[1400px] mx-auto" data-id="element-16" data-mp="27m7jxrmvro2x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-17" data-mp="27nirm2jg5fzb">
          <div className="lg:col-span-5" data-id="element-18" data-mp="2mbvor2u9t4ve">
            <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-5" data-id="element-19" data-mp="2mcx25dyre3ga">
              Avance 03 · Acuerdos con PNN
            </span>
            <h2 className="text-4xl md:text-5xl font-serif text-forest leading-[1.05]" data-id="element-20" data-mp="2vah0ae1brjmo">
              Acuerdos de conservación en el PNN Paramillo
            </h2>
            <p className="text-lg text-charcoal/70 font-light leading-relaxed mt-5" data-id="element-21" data-mp="359g15afumaz4">
              Seguimos avanzando en la consolidación de los acuerdos de
              conservación en el PNN Paramillo
            </p>
          </div>
          <div className="lg:col-span-7 lg:pt-3 space-y-5 text-charcoal/80 font-light leading-relaxed" data-id="element-22" data-mp="1awggv40iwsli">
            <p className="text-lg md:text-xl text-charcoal/85" data-id="element-23" data-mp="15xvplu391j97">
              Desde 2023, en el marco del Proyecto TEFOS, Parques Nacionales
              Naturales de Colombia ha venido suscribiendo acuerdos de
              conservación, de gestión y metodológicos con familias campesinas
              vulnerables del PNN Paramillo.
            </p>
            <p data-id="element-24" data-mp="3ct7e6ldcjq64">
              Estos acuerdos buscan armonizar los derechos del ambiente y del
              campesinado, contribuyendo a la conservación y el manejo
              sostenible de la biodiversidad, así como a la reducción de la
              deforestación en el área protegida. Mediante estos compromisos,
              las familias acuerdan no realizar actividades como tala, cacería y
              quema, mientras que, de manera concertada, se implementan acciones
              para mejorar su calidad de vida y fortalecer medios de vida
              sostenibles.
            </p>
          </div>
        </div>

        {/* Stats + actions panel */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 lg:grid-cols-12 gap-0 bg-forest text-bone overflow-hidden mb-16" data-id="element-25" data-mp="s26zgjmbjgrl">
          <div className="lg:col-span-5 relative min-h-[320px] lg:min-h-0 bg-bone flex flex-col" data-id="element-26" data-mp="2a5k6ngsbjkf6">
            <img src="https://cdn.magicpatterns.com/uploads/ejnwpN3hzDtWzcFmqQhvmj/numerodepersonasenparamillo_001.png" alt="Mapa del PNN Paramillo con el número de personas vinculadas a los acuerdos de conservación por municipio" className="w-full flex-1 min-h-0 object-contain p-4" data-id="element-27" data-mp="258254bgms7h7" />
            <figcaption className="text-charcoal/55 text-[11px] font-light leading-relaxed px-4 pb-4" data-id="element-28" data-mp="1re14fc64cae7">
              Fuente: mapa no oficial, elaborado con base en información de
              2025, tomada de la{' '}
              <a href="https://data-agenciadetierras.opendata.arcgis.com/datasets/8944116ccfd34a7189c4bc44b8e19186_0/explore" target="_blank" rel="noopener noreferrer" className="text-clay underline underline-offset-2 hover:text-forest transition-colors" data-id="element-29" data-mp="17dzrmz2fgj7i">
                ANT
              </a>{' '}
              y del{' '}
              <a href="https://geoportal.dane.gov.co/servicios/descarga-y-metadatos/datos-geoestadisticos/" target="_blank" rel="noopener noreferrer" className="text-clay underline underline-offset-2 hover:text-forest transition-colors" data-id="element-30" data-mp="oni02xtbztnq">
                DANE, del 2018
              </a>
              .
            </figcaption>
          </div>
          <div className="lg:col-span-7 p-8 md:p-12 lg:p-14" data-id="element-31" data-mp="5vpalddh0qkr">
            <span className="text-clay-light text-xs uppercase tracking-[0.2em] font-semibold" data-id="element-32" data-mp="avv4l077qp60">
              Resultados a la fecha
            </span>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 mt-6 mb-10 pb-10 border-b border-bone/15" data-id="element-33" data-mp="2tuikwd0ezln">
              <div data-id="element-34" data-mp="3u0x8lkh42zua">
                <div className="font-serif text-clay-light text-6xl md:text-7xl leading-none" data-id="element-35" data-mp="3tzm8bumvka7x">
                  195
                </div>
                <div className="text-bone/70 text-sm mt-3 font-light" data-id="element-36" data-mp="7lm0yjm0hz0p">
                  Acuerdos de conservación firmados
                </div>
              </div>
              <div data-id="element-37" data-mp="3g3igu93dyfz5">
                <div className="font-serif text-clay-light text-6xl md:text-7xl leading-none" data-id="element-38" data-mp="3b2uguxx6ioss">
                  19
                </div>
                <div className="text-bone/70 text-sm mt-3 font-light" data-id="element-39" data-mp="3q0mtnibccz3a">
                  Acuerdos metodológicos firmados
                </div>
              </div>
              <div data-id="element-40" data-mp="159e37rzxfqf5">
                <div className="font-serif text-clay-light text-6xl md:text-7xl leading-none" data-id="element-41" data-mp="158l154bwxp3c">
                  47%
                </div>
                <div className="text-bone/70 text-sm mt-3 font-light" data-id="element-42" data-mp="10cnl6z4kakr3">
                  Avance de implementación a mayo de 2026
                </div>
              </div>
            </div>

            <div className="text-xs uppercase tracking-[0.2em] text-bone/60 font-semibold mb-5" data-id="element-43" data-mp="1cugi2x7b83am">
              Acciones concertadas
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-44" data-mp="12ufugz2er10m">
              {ACTIONS.map(action => {
              const Icon = action.icon;
              return <div key={action.label} className="flex items-center gap-3" data-id="element-45" data-mp="1vjn3wt3ehb0n">
                    <Icon className="text-clay-light flex-none" size={20} strokeWidth={1.5} data-id="element-46" data-mp="1vlr5339wzvx8" />
                    <span className="text-bone/90 text-sm font-light" data-id="element-47" data-mp="1lsae0715wux9">
                      {action.label}
                    </span>
                  </div>;
            })}
            </div>
          </div>
        </motion.div>

        {/* Two windows: videos + boletines */}
        <div className="mb-2" data-id="element-48" data-mp="1pk9yhmcggp0e">
          <h3 className="font-serif text-2xl md:text-3xl text-forest mb-3" data-id="element-49" data-mp="1plkz5daltgna">
            Explora los avances
          </h3>
          <p className="text-charcoal/70 font-light leading-relaxed mb-8 max-w-2xl" data-id="element-50" data-mp="1ftfbugvarnef">
            Conoce más sobre este proceso y explora los videos y documentos que
            registran los avances y resultados del trabajo junto a las
            comunidades del PNN Paramillo.
          </p>
        </div>
        {/* Videos embebidos */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-51" data-mp="23kkrow18mfoq">
          {VIDEOS.map((video, i) => <motion.figure key={video.src} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-52" data-mp="1yilnxl1l5gr9" data-mpi={i}>
              <div className="relative w-full bg-charcoal overflow-hidden" style={{
            aspectRatio: '16/9'
          }} data-id="element-53" data-mp="2tv39swbowz4b">
                <iframe loading="lazy" title={video.title} src={video.src} style={{
              border: 'none',
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              width: '100%'
            }} referrerPolicy="origin" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen;clipboard-write;" data-id="element-54" data-mp="33pvawa4he43u" />
              </div>
              <figcaption className="text-charcoal/70 text-sm font-light mt-3" data-id="element-55" data-mp="1s57wv1ixk75n">
                {video.title}
              </figcaption>
            </motion.figure>)}
        </div>

        {/* Horizontal video */}
        <motion.figure initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-6" data-id="element-56" data-mp="3lh17s4v0ei7c">
          <div className="relative w-full bg-charcoal overflow-hidden" style={{
          aspectRatio: '16/9'
        }} data-id="element-57" data-mp="3a3fez6au1zo">
            <iframe loading="lazy" title={HORIZONTAL_VIDEO.title} src={HORIZONTAL_VIDEO.src} style={{
            border: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%'
          }} referrerPolicy="origin" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen;clipboard-write;" data-id="element-58" data-mp="d6y7az82h44z" />
          </div>
          <figcaption className="text-charcoal/70 text-sm font-light mt-3" data-id="element-59" data-mp="2ghbeio8j9cqy">
            {HORIZONTAL_VIDEO.title}
          </figcaption>
        </motion.figure>

        {/* Vertical videos */}
        <div className="grid grid-cols-2 gap-6 max-w-2xl mx-auto mb-10" data-id="element-60" data-mp="27fvb50g4yaw8">
          {VERTICAL_VIDEOS.map((video, i) => <motion.figure key={video.src} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-61" data-mp="22ilfh325l2zy" data-mpi={i}>
              <div className="relative w-full bg-charcoal overflow-hidden" style={{
            aspectRatio: '9/16'
          }} data-id="element-62" data-mp="3iuiciteqz512">
                <iframe loading="lazy" title={video.title} src={video.src} style={{
              border: 'none',
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              width: '100%'
            }} referrerPolicy="origin" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen;clipboard-write;" data-id="element-63" data-mp="3e1xm81v1va2a" />
              </div>
              <figcaption className="text-charcoal/70 text-sm font-light mt-3" data-id="element-64" data-mp="3j6j8gjxddnhc">
                {video.title}
              </figcaption>
            </motion.figure>)}
        </div>

        {/* Boletines window */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-forest text-bone p-8 md:p-10" data-id="element-65" data-mp="13hhvjnmfo2xn">
          <div className="flex items-center gap-5 mb-8" data-id="element-66" data-mp="2nzilljrl75pf">
            <div className="w-14 h-14 bg-clay flex items-center justify-center text-bone flex-none" data-id="element-67" data-mp="2o13g59dwiona">
              <FileText size={24} data-id="element-68" data-mp="31s8bhza8kurt" />
            </div>
            <div data-id="element-69" data-mp="2wzowqyztbtlf">
              <h4 className="font-serif text-2xl md:text-3xl leading-tight" data-id="element-70" data-mp="2wz5q4efm4rmp">
                Boletines
              </h4>
              <p className="text-bone/70 text-sm font-light mt-1" data-id="element-71" data-mp="3bnjuitsogo5d">
                Documentos que registran los avances del proceso.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-72" data-mp="3kohyjc348vny">
            {BOLETINES.map(boletin => <a key={boletin.href} href={boletin.href} target="_blank" rel="noopener noreferrer" className="group flex items-center justify-between gap-3 border border-bone/20 hover:border-clay-light hover:bg-bone/5 px-5 py-4 transition-colors" data-id="element-73" data-mp="3frhu15lx00yy">
                <span className="font-medium text-bone/95" data-id="element-74" data-mp="1rse95dp6lwv8">
                  {boletin.label}
                </span>
                <ArrowRight size={18} className="text-clay-light flex-none transform group-hover:translate-x-1 transition-transform" data-id="element-75" data-mp="1wt1zry9i0box" />
              </a>)}
          </div>
        </motion.div>
      </div>
    </section>;
}